import { render, staticRenderFns } from "./SectionData.vue?vue&type=template&id=70c6536c"
import script from "./SectionData.vue?vue&type=script&lang=js"
export * from "./SectionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports